/**
 * Collection Carousel Section
 * Horizontal scrolling product carousel with drag-to-scroll + momentum
 * inertia (desktop only). Touch scrolling is handled natively by the browser.
 */
(function () {
  function initCarousel(container) {
    var grid = container.querySelector('.oddit-section-collection-carousel__products-grid');
    if (!grid) return;

    // Always start the carousel at the first card on load.
    requestAnimationFrame(function () { grid.scrollLeft = 0; });

    var isDown = false;
    var startX;
    var scrollLeft;
    var moved = false;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var inertiaRaf = null;

    function stopInertia() {
      if (inertiaRaf) {
        cancelAnimationFrame(inertiaRaf);
        inertiaRaf = null;
      }
    }

    grid.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function onMouseDown(e) {
      if (e.button !== 0) return;
      // Allow drag from anywhere on a card (incl. images wrapped in <a>) to
      // match the New Arrivals carousel behavior — Kael flagged that these
      // two should function the same (ELA-121). Only skip drag when the
      // user grabs an interactive control we don't want hijacked: swatches
      // (which need a clean click for color change). Click events on the
      // anchor wrappers are blocked below if a drag actually happened.
      if (e.target.closest('[data-swatch]')) return;
      stopInertia();
      isDown = true;
      moved = false;
      startX = e.pageX;
      scrollLeft = grid.scrollLeft;
      lastX = e.pageX;
      lastTime = performance.now();
      velocity = 0;
    }

    function onMouseMove(e) {
      if (!isDown) return;
      var walk = e.pageX - startX;
      if (!moved && Math.abs(walk) > 3) {
        moved = true;
        grid.classList.add('is-dragging');
      }
      if (moved) {
        e.preventDefault();
        grid.scrollLeft = scrollLeft - walk;
        var now = performance.now();
        var dt = now - lastTime;
        if (dt > 0) {
          velocity = (e.pageX - lastX) / dt;
        }
        lastX = e.pageX;
        lastTime = now;
      }
    }

    function onMouseUp() {
      if (!isDown) return;
      isDown = false;
      grid.classList.remove('is-dragging');
      if (!moved || Math.abs(velocity) < 0.1) return;

      var v = velocity;
      var prevFrame = performance.now();
      function step() {
        var now = performance.now();
        var dt = now - prevFrame;
        prevFrame = now;
        grid.scrollLeft -= v * dt;
        v *= Math.pow(0.94, dt / 16);
        if (Math.abs(v) > 0.02) {
          inertiaRaf = requestAnimationFrame(step);
        } else {
          inertiaRaf = null;
        }
      }
      inertiaRaf = requestAnimationFrame(step);
    }

    grid.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove, { passive: false });
    document.addEventListener('mouseup', onMouseUp);

    // Stop inertia if user starts scrolling another way (wheel) or interacts elsewhere
    grid.addEventListener('wheel', stopInertia, { passive: true });

    grid.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    container._carouselCleanup = function () {
      grid.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      grid.removeEventListener('wheel', stopInertia);
      stopInertia();
    };
  }

  document.querySelectorAll('.oddit-section-collection-carousel').forEach(function (section) {
    initCarousel(section);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-section-collection-carousel');
    if (section) {
      initCarousel(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.oddit-section-collection-carousel');
    if (section && section._carouselCleanup) {
      section._carouselCleanup();
    }
  });
})();
